import { Directive } from "vue";
import SmilesDrawer from "smiles-drawer";

export const vSmiles: Directive = {
    mounted: (el: HTMLInputElement, binding) => {
        let smiles = binding.value;

        let options = {
            compactDrawing: false,
            bondThickness: 2.5,
            fontSizeLarge: 15,
            width: el.offsetWidth,
            height: el.offsetHeight,
            padding: 0,
        };

        if (smiles.length === 0) {
            // this.el.getContext('2d')
        }

        const drawer = new SmilesDrawer.Drawer(options);
        SmilesDrawer.parse(
            smiles,
            (tree: any) => {
                drawer.draw(tree, el, "light", false);
            },
            (error: any) => {
                // console.log(error);
            },
        );
    },
};
